import styles from "./ContentPage.module.css";

/**
 * Visible callout shown at the top of every legal page while the documents
 * are still being reviewed. The copy is intentionally honest and explicitly
 * approved.
 */
export function LegalDraftNotice() {
  return (
    <div className={styles.callout} role="note">
      <svg
        className={styles.calloutIcon}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4" />
        <path d="M12 16h.01" />
      </svg>
      <p className={styles.calloutText}>
        <strong>This is a working draft pending legal review.</strong>
      </p>
    </div>
  );
}

export default LegalDraftNotice;
